import { DateTimeRange } from "../date-time";
import { LocalTimeFunc } from "./local-time";
// 日跨ぎとなる時刻の指定も可 （ ex.22:00~01:00 )
export class TimeRange {
    v;
    constructor(v) {
        this.v = v;
    }
    static of({ startAt: startAtValues, endAt: endAtValues }) {
        const startAt = LocalTimeFunc.of(startAtValues);
        const endAt = LocalTimeFunc.of(endAtValues);
        return this.between({ startAt, endAt });
    }
    static between({ startAt, endAt }) {
        return new TimeRange({ startAt, endAt });
    }
    // startもendも同じ時刻の場合は同日扱い
    isAcrossDays() {
        return this.v.endAt.isBefore(this.v.startAt);
    }
    atDate(date) {
        const endOn = this.isAcrossDays() ? date.addDays(1) : date;
        return DateTimeRange.between({
            startAt: date.atTime(this.v.startAt),
            endAt: endOn.atTime(this.v.endAt),
        });
    }
    static union(...timeRanges) {
        return timeRanges.reduce((sum, d) => this.unionInternal(sum, d));
    }
    static unionInternal(a, b) {
        return TimeRange.between({
            startAt: a.v.startAt.isBefore(b.v.startAt) ? a.v.startAt : b.v.startAt,
            endAt: a.v.endAt.isBefore(b.v.endAt) ? b.v.endAt : a.v.endAt,
        });
    }
    toValues() {
        return {
            startAt: this.v.startAt.toValues(),
            endAt: this.v.endAt.toValues(),
        };
    }
}
//# sourceMappingURL=time-range.js.map